import { put, takeEvery } from "redux-saga/effects";
import { fetchOpportunityHistory, setOpportunityHistoryTxnOppId, 
    setOpportunityHistory, setIsOpportunityHistoryLoading, 
    setIsViewOpportunityHistoryModalOpen, appNotify } from "../../store/actions";
import { getWithToken } from "../../api/network";

export function* getOpportunityHistorySaga() {
    yield takeEvery(fetchOpportunityHistory, function* ({ payload }) {
        try {
            yield put(setOpportunityHistoryTxnOppId(payload.txnOppId));
            yield put(setIsOpportunityHistoryLoading(true));
            yield put(setIsViewOpportunityHistoryModalOpen(true));

            const url = `/api/underwrite/workflow/opportunityHistory/GetOpportunityHistory/${payload.txnOppId}`;
            const response = yield getWithToken(url);
            const data = yield response.json();

            yield put(setOpportunityHistory(data));
            yield put(setIsOpportunityHistoryLoading(false));
        } catch (e) {
            yield put(appNotify(`Error fetching Opportunity History | ${e.message}`, 'error'));
        } finally {
            yield put(setIsOpportunityHistoryLoading(false));
        }
    });
}